/* eslint-disable  */

import { getScript } from '@/commons/utils';
import { AutocompleteGeneric } from './ac-generic';
import { googleConfig } from '@/modules-es5/pages/store-locator/store-locator-config.js';

const URL_SCRIPT =
  googleConfig &&
  googleConfig.language &&
  googleConfig.country &&
  googleConfig.key &&
  googleConfig.channelId &&
  `https://maps.googleapis.com/maps/api/js?language=${googleConfig.language}&region=${googleConfig.country}&key=${googleConfig.key}&channel=${googleConfig.channelId}&libraries=geometry,places`;
export class AutocompleteGoogle extends AutocompleteGeneric {
  // get the required scripts to run Google Autocomplete
  getLibrary() {
    if (!window.google || !window.google.maps) return getScript(URL_SCRIPT).then(() => this.initSpecific());
    this.initSpecific();
    return Promise.resolve();
  }

  // init specific Google services
  initSpecific() {
    this.serviceAComplete = new window.google.maps.places.AutocompleteService();
    this.servicePlaces = new window.google.maps.places.PlacesService(this.$input);
  }

  // from an 'input' val
  // returns a list a 'suggestions', through the 'resolvePromise' callback
  searchSuggestions(input, resolvePromise) {
    this.serviceAComplete.getPlacePredictions(
      {
        input,
        types: ['geocode'],
        componentRestrictions: { country: this.config.country },
      },
      resolvePromise
    );
  }

  // from a 'suggestion'
  // returns a detailed 'position', through the 'resolvePromise' callback
  searchPosition(suggestion, resolvePromise) {
    this.servicePlaces.getDetails({ placeId: suggestion.place_id }, place =>
      resolvePromise({
        name: place.name,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        formatted_address: place.formatted_address,
        address_components: place.address_components,
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/commons/component/autocomplete/ac-google.js